import { render } from "./PersonalCert.vue?vue&type=template&id=1c375aa2"
import script from "./PersonalCert.vue?vue&type=script&lang=js"
export * from "./PersonalCert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__